"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadWobbleUpdater = void 0;
const WobbleUpdater_1 = require("./WobbleUpdater");
function loadWobbleUpdater(tsParticles) {
    tsParticles.addParticleUpdater("wobble", () => new WobbleUpdater_1.WobbleUpdater());
}
exports.loadWobbleUpdater = loadWobbleUpdater;
